import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=0be58882&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=ts&"
export * from "./Timer.vue?vue&type=script&lang=ts&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=0be58882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be58882",
  null
  
)

export default component.exports